const links1 = [
  { label: "Home", href: "/" },
  { label: "About Us", href: "/about" },
  { label: "Contact Us", href: "/contact" },
  { label: "Our Work", href: "/ourWork" },
  { label: "Sample Projects", href: "/projects" },
  { label: "Careers ", href: "/careers" },
];

const links2 = [
  { label: "MVP Development", href: "/mvp" },
  { label: "Web Development", href: "/webApp" },
  { label: "Mobile App Development", href: "/mobileApp" },
  { label: "UI/UX Design", href: "/uiux" },
  {
    label: "Custom Software Development",
    href: "software-development",
  },
  { label: "Cloud & DevOps", href: "/cloud" },
  { label: "AI & Data Solutions", href: "data&ai" },
  {
    label: "System Integrations",
    href: "/software-integration",
  },
];

const links3 = [
  { label: "Privacy Policy", href: "/privacy-policy" },
  { label: "Terms of Service", href: "/terms" },
  // { label: "Return & Refund Policy", href: "/return-refund" },
];

// Rendered as a stacked card in the footer's left column, one entry per office
// with a divider between them.
const offices = [
  {
    country: "Sri Lanka",
    address: "ICIEOS, Level 35, West Tower, World Trade Center, Colombo 01, Sri Lanka.",
  },
  {
    country: "United States",
    address: "ICIEOS LLC, 224 W 35th St Ste 500, #2395, New York, NY 10001",
  },
];

export { links1, links2, links3, offices };
